export class PaymentProcessStatusResponse {
  paymentProcessStatus: string;
}
